export default __webpack_public_path__ + "static/media/home-slide3.7c3eda37.png";